import axios from "axios";

export default {
  namespaced: true,
  state: {
    inventories: [],
    inventory: {},
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    inventoriesMessage: ''
  },
  mutations: {
    CLEAR_INVENTORIES(state) {
      state.inventories = [];
    },
    RECEIVED_INVENTORY(state, payload) {
      state.inventory = payload;
      state.isReceiving = false;
    },
    RECEIVED_INVENTORIES(state, payload) {
      state.inventories = payload;
      state.isReceiving = false;
    },
    
    RECEIVING_INVENTORIES(state) {
      state.isReceiving = true;
    },
    RECEIVING_INVENTORY(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },


    UPDATED_INVENTORY(state, payload) {
      let index = state.inventories.findIndex(inventory => inventory._id === payload._id);
      state = Object.assign(state, {
        inventories: state.inventories.map((inventory, i) => {
          if (i === index) {
            return Object.assign({}, inventory, payload);
          }
          return inventory;
        }),
        isUpdating: false,
        inventoriesMessage: 'Inventories has been updating!',
      })
    },
    UPDATING_INVENTORY(state) {
      state.isUpdating = true;
    },
    DELETED_INVENTORY(state) {
      state.inventory = {};
      state = Object.assign(state, {
        isDeleting: false,
        idToDelete: null,
        inventoriesMessage: 'Inventory has been Deleted!',
      });
    },
    DELETING_INVENTORY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteInventoryRequest({dispatch}, payload) {
      try {
        dispatch("deletingInventory", payload);
        let token = localStorage.getItem('token')
        let url = 'https://api.accountxc.com:3100/delete/inventory/' + payload._id;
        let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
        let response = await axios({method: "delete", url: url, headers: headers})
        dispatch("deleteInventory", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }
    },
    async deleteIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/ivjtransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertInventoryRequest({dispatch}, payload) {
      dispatch("receivingInventories");
      var token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/inventory';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      let inventory = response.data;
      dispatch("receiveInventory", inventory);
      return inventory;
    },
    async insertIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/ivjtransaction/" + payload.inventoryid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getInventoryRequest({dispatch}) {
      dispatch("receivingInventory");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/inventory';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(res => {
        dispatch("receiveInventory", res.data);
      })
    },
    async findInventoryRequest({dispatch}, payload) {
      try{
        dispatch("receivingInventory");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/inventory';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveInventory", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getInventoryQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingInventories");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/inventory/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveInventories", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateInventoryRequest({dispatch}, payload) {
      dispatch("updatingInventory");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/inventory/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateInventory", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    updateInventoryTrade({dispatch}, payload) {
      dispatch("updatingInventory");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/inventory/trade/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put",url: url,headers: headers,data: payload})
      .then((response)=> {
        dispatch("updateInventory", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateInventoryTransaction({dispatch}, payload) {
      try{
        dispatch("receivingInventory");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/ivjtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingInventory", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearInventories({commit}) {
      commit("CLEAR_INVENTORIES")
    },


    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receiveInventory({commit}, payload) {
      commit("RECEIVED_INVENTORY", payload)
    },
    receiveInventories({commit}, payload) {
      commit("RECEIVED_INVENTORIES", payload)
    },
    receivingInventory({commit}) {
      commit("RECEIVING_INVENTORY")
    },
    receivingInventories({commit}) {
      commit("RECEIVING_INVENTORIES")
    },
    updateInventory({commit}, payload) {
      commit("UPDATED_INVENTORY", payload)
    },
    updatingInventory({commit}) {
      commit("UPDATING_INVENTORY")
    },
    deleteInventory({commit}, payload) {
      commit("DELETED_INVENTORY", payload)
    },
    deletingInventory({commit}, payload) {
      commit("DELETING_INVENTORY", payload)
    }
  },
};
